import DashboardLayout from "@/layout/dashboard/DashboardLayout.vue";
// GeneralViews
import NotFound from "@/pages/NotFoundPage.vue";
import Login from "@/pages/LoginPage.vue";
import Register from "@/pages/RegisterPage.vue";
import RegisterSuccess from "@/pages/RegisterSuccessPage.vue";
import VerifyEmail from "@/pages/VerifyEmailPage.vue";
import VerifyEmailSendSuccess from "@/pages/VerifyEmailSendSuccessPage.vue";
import ResetPassword from "@/pages/ResetPasswordPage.vue";
import ResetPasswordSendSuccess from "@/pages/ResetPasswordSendSuccessPage.vue";
import ResetPasswordLand from "@/pages/ResetPasswordLandPage.vue";
import ResetPasswordSuccess from "@/pages/ResetPasswordSuccessPage.vue";
import ResetEmailSendSuccess from "@/pages/ResetEmailSendSuccessPage.vue";
import ResetEmailLand from "@/pages/ResetEmailLandPage.vue";
import ResetEmailSuccess from "@/pages/ResetEmailSuccessPage.vue";

// Admin pages
import Dashboard from "@/pages/Dashboard.vue";
import UserProfile from "@/pages/UserProfile.vue";
import InvoiceInfo from "@/pages/InvoiceInfo.vue";
import Plans from "@/pages/Plans.vue";
import Payments from "@/pages/Payments.vue";
import Payment from "@/pages/Payment.vue";
import PaymentSuccess from "@/pages/PaymentSuccess.vue";
import PaymentError from "@/pages/PaymentError.vue";
// import Notifications from "@/pages/Notifications.vue";
// import Icons from "@/pages/Icons.vue";
// import Maps from "@/pages/Maps.vue";
// import Typography from "@/pages/Typography.vue";
// import TableList from "@/pages/TableList.vue";

const routes = [
  {
    path: "/",
    component: DashboardLayout,
    redirect: "/home",
    meta: {
      requiresAuth: true,
      requiresActions: ['accounts_access']
    },
    children: [
      {
        path: "home",
        name: "home",
        component: Dashboard
      },
      {
        path: "profile",
        name: "profile",
        component: UserProfile
      },
      {
        path: "invoice",
        name: "invoice",
        component: InvoiceInfo
      },
      {
        path: "plans",
        name: "plans",
        component: Plans
      },
      {
        path: "/payments",
        name: "payments",
        component: Payments,
      },
      {
        path: "/payments/:reference_id",
        name: "payment",
        component: Payment,
      },
      {
        path: "/payment/success",
        name: "success",
        component: PaymentSuccess,
      },
      {
        path: "/payment/error",
        name: "error",
        component: PaymentError,
      },
      // {
      //   path: "notifications",
      //   name: "notifications",
      //   component: Notifications
      // },
      // {
      //   path: "icons",
      //   name: "icons",
      //   component: Icons
      // },
      // {
      //   path: "maps",
      //   name: "maps",
      //   component: Maps
      // },
      // {
      //   path: "typography",
      //   name: "typography",
      //   component: Typography
      // },
      // {
      //   path: "table-list",
      //   name: "table-list",
      //   component: TableList
      // }
    ]
  },
  {
    path: "/login",
    name: "login",
    component: Login,
  },
  {
    path: "/register",
    name: "register",
    component: Register,
  },
  {
    path: "/register_success",
    name: "register_success",
    component: RegisterSuccess,
  },
  {
    path: "/verify_email_send_success",
    name: "verify_email_send_success",
    component: VerifyEmailSendSuccess,
  },
  {
    path: "/verify_email/:token",
    name: "verify_email",
    component: VerifyEmail,
  },
  {
    path: "/reset_password",
    name: "reset_password",
    component: ResetPassword,
  },
  {
    path: "/reset_password_send_success",
    name: "reset_password_send_success",
    component: ResetPasswordSendSuccess,
  },
  {
    path: "/reset_password_land/:token",
    name: "reset_password_land",
    component: ResetPasswordLand,
  },
  {
    path: "/reset_password_success",
    name: "reset_password_success",
    component: ResetPasswordSuccess,
  },
  {
    path: "/reset_email_send_success",
    name: "reset_email_send_success",
    component: ResetEmailSendSuccess,
  },
  {
    path: "/reset_email_land/:token/:email",
    name: "reset_email_land",
    component: ResetEmailLand,
  },
  {
    path: "/reset_email_success",
    name: "reset_email_success",
    component: ResetEmailSuccess,
  },
  { path: "*", component: NotFound }
];

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/

export default routes;
